import { injectable } from 'tsyringe';
import { OWWindowsListener, OWWindowsListenerDelegate } from '../../odk-ts';
import { DelegateProvider } from 'app-core/src/interfaces/delegate-provider.interface';

// -----------------------------------------------------------------------------

@injectable()
export class OWWindowListenerWrapper
  implements DelegateProvider<OWWindowsListenerDelegate>
{
  private readonly listeners: Map<OWWindowsListenerDelegate, OWWindowsListener>;

  // ---------------------------------------------------------------------------
  public constructor() {
    this.listeners = new Map<OWWindowsListenerDelegate, OWWindowsListener>();
  }

  // ---------------------------------------------------------------------------
  // DelegateProvider
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  addListener(listener: OWWindowsListenerDelegate) {
    this.removeListener(listener);
    this.listeners.set(listener, new OWWindowsListener(listener, true));
  }

  // ---------------------------------------------------------------------------
  removeListener(listener: OWWindowsListenerDelegate) {
    const windowListener = this.listeners.get(listener);
    if (!windowListener) {
      return;
    }

    windowListener.stop();
    this.listeners.delete(listener);
  }
}
